__turbopack_context__.v({
  "buttonContainer": "DestinationArticlesCarouselSection-module__y_wUIW__buttonContainer",
  "carousel": "DestinationArticlesCarouselSection-module__y_wUIW__carousel",
  "title": "DestinationArticlesCarouselSection-module__y_wUIW__title",
});
